import React, { useContext } from "react";
import { Col, Row } from "react-bootstrap";
import { useFieldArray } from "react-hook-form";
import { FormattedMessage } from "react-intl";
import removeImg from "../../assets/svgs/close.svg";

import InputGroupField from "components/FormGroupFields/InputGroupField";
import TextareaGruopField from "components/FormGroupFields/TextareaGruopField";
import ImageGroupField from "components/FormGroupFields/ImageGroupField";
import { SelectGroupField } from "components/FormGroupFields/SelectGroupField";
import { Context } from "components/Form";

const InputsGroup = ({ name, title = name, inputs = [], lg = "6" }) => {
  const { register, control, errors } = useContext(Context);
  const { fields, append, remove } = useFieldArray({
    control,
    name: name,
  });

  // render inputs
  const renderInputs = (index) => {
    return inputs?.map((input) => {
      if (input?.locales?.length) {
        return input?.locales?.map((locale) => {
          if (input?.type === "textarea") {
            return (
              <TextareaGruopField
                key={`${name}.${index}.${input?.name}.${locale}`}
                parentName={name}
                index={index}
                input={input}
                locale={locale}
                register={register}
                errors={errors}
                type={input?.type}
                rules={input?.rules}
                lg={input?.lg}
              />
            );
          }

          return (
            <InputGroupField
              key={` ${name}.${index}.${input?.name}.${locale}`}
              parentName={name}
              index={index}
              input={input}
              locale={locale}
              register={register}
              errors={errors}
              type={input?.type}
              rules={input?.rules}
              lg={input?.lg}
            />
          );
        });
      }

      if (input?.type === "textarea") {
        return (
          <TextareaGruopField
            key={`${name}.${index}.${input?.name}`}
            parentName={name}
            index={index}
            input={input}
            register={register}
            errors={errors}
            type={input?.type}
            rules={input?.rules}
            lg={input?.lg}
          />
        );
      }

      if (input?.type === "image") {
        return (
          <ImageGroupField
            control={control}
            key={`${name}.${index}.${input?.name}`}
            parentName={name}
            index={index}
            input={input}
            errors={errors}
            type={input?.type}
            rules={input?.rules}
            lg={input?.lg}
          />
        );
      }
      if (input?.type === "select") {
        return (
          <SelectGroupField
            key={`${name}.${index}.${input?.name}`}
            parentName={name}
            index={index}
            input={input}
            register={register}
            errors={errors}
            type={input?.type}
            rules={input?.rules}
            lg={input?.lg}
            labelName={input?.labelName}
            valueName={input?.valueName}
          />
        );
      }

      return (
        <InputGroupField
          key={`${name}.${index}.${input?.name}`}
          parentName={name}
          index={index}
          input={input}
          register={register}
          errors={errors}
          type={input?.type}
          rules={input?.rules}
          lg={input?.lg}
        />
      );
    });
  };
  return (
    <div className="form-group branches features">
      <h5>
        {!!title && <FormattedMessage id={title} />}
        <button
          type="button"
          className="btn btn-green"
          onClick={() => {
            append();
          }}
        >
          <FormattedMessage id="add" />
        </button>
      </h5>
      <Row>
        {fields.map((item, index) => {
          return (
            <Col xl={lg} lg={lg} md={lg} xs={12} key={index}>
              <div className="add-multi-component">
                <button
                  type="button"
                  onClick={() => remove(index)}
                  className="removeImg"
                >
                  <img src={removeImg} alt="" />
                </button>
                <Row>{renderInputs(index)}</Row>
              </div>
            </Col>
          );
        })}
      </Row>
    </div>
  );
};

export default InputsGroup;
